import { $ } from "../../utils/dom";

const EXTRA_PADDING = 20;
const HEADER_HEIGHT_VAR = "--js-header-height";

function handleHeaderHeight() {
    const header = $('.js-siteHeader')
    if (!header) return;

    const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
            if (entry.contentBoxSize) {
                const [headerBoxSize] = entry.contentBoxSize;
                const scrollPadding = headerBoxSize.blockSize + EXTRA_PADDING;
                const currentHeight = getComputedStyle(document.body).getPropertyValue(HEADER_HEIGHT_VAR)?.replace(/\D/g, '');

                if (!currentHeight || Number(currentHeight) !== scrollPadding) {
                    return document.documentElement.style.setProperty(HEADER_HEIGHT_VAR, scrollPadding + 'px')
                }
            }
        }
    })

    resizeObserver.observe(header);
}

export const onContentLoaded = (): void => {
    handleHeaderHeight();
};

if (process.env.NODE_ENV !== "development") {
    document.addEventListener("DOMContentLoaded", onContentLoaded);
}
